import { BasicHeadCell } from '../../../models/BasicTable/BasicTableProps';
import { CartHeadProps } from '../../../models/Cart';

export const CART_HEAD_CELLS: BasicHeadCell<CartHeadProps>[] = [
    {
        id: 'id',
        disablePadding: true,
        label: 'PRODUCT',
    },
    {
        id: 'cost',
        disablePadding: true,
        label: 'PRICE',
    },
    {
        id: 'quantity',
        disablePadding: true,
        label: 'QUANTITY',
    },
    {
        id: 'cost',
        disablePadding: true,
        label: 'PRICE_TOTAL',
    },
    {
        id: 'actions',
        disablePadding: true,
        label: 'ACTIONS',
    },
];
